export default "__VITE_ASSET__CvNCD8Re__"